import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../context/AuthContext";
import Seo from "../components/Seo";
import SmartImage from "../components/SmartImage";
import { useLanguage } from "../context/LanguageContext";

export default function Blog() {
  const { language, t } = useLanguage();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`${API}/blog?limit=30`).then(r => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
      <Seo
        title="Blog Rarium — Guide alle Aste e al Collezionismo"
        description="Guide editoriali sulle aste online: come collezionare orologi vintage, comprare arte all'asta, valutare gioielli, auto classiche, vini pregiati e libri rari. A cura del team Rarium."
        path="/blog"
      />
      <div className="max-w-3xl">
        <div className="overline text-stone-500">{t("Editoriale")}</div>
        <h1 className="font-serif text-5xl sm:text-6xl tracking-tighter mt-2">{t("Il blog delle aste.")}</h1>
        <p className="mt-4 text-stone-600 leading-relaxed">
          {t("Guide, consigli e storie del collezionismo — a cura del team editoriale Rarium. Un nuovo articolo ogni settimana.")}
        </p>
      </div>

      {loading ? (
        <div className="mt-16 text-stone-500">{t("Caricamento…")}</div>
      ) : posts.length === 0 ? (
        <div className="mt-16 border-t border-stone-200 pt-16 text-center">
          <div className="font-serif text-3xl">{t("Prossimo articolo in arrivo.")}</div>
          <p className="mt-3 text-stone-500 max-w-md mx-auto">{t("Il nostro editore pubblica un nuovo articolo ogni settimana. Torna presto o iscriviti alla newsletter.")}</p>
        </div>
      ) : (
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {posts.map((p, i) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug}`}
              data-testid={`blog-card-${p.slug}`}
              className="group flex flex-col gap-4 fade-up"
              style={{ animationDelay: `${Math.min(i * 60, 300)}ms` }}
            >
              <div className="zoom-wrap aspect-[4/3] bg-stone-100">
                <SmartImage src={p.cover_image} alt={p.title} className="w-full h-full object-cover" fallbackText={p.title} />
              </div>
              <div>
                <div className="overline text-stone-500 capitalize">{(p.category || "").replace(/-/g, " ")}</div>
                <h2 className="font-serif text-2xl leading-snug mt-2 group-hover:text-[#8C3A3A] transition-colors line-clamp-3">{p.title}</h2>
                <p className="mt-3 text-sm text-stone-600 leading-relaxed line-clamp-3">{p.excerpt}</p>
                <div className="mt-4 text-xs text-stone-500">
                  {p.published_at ? new Date(p.published_at).toLocaleDateString(language === "en" ? "en-IE" : "it-IT", { day: "numeric", month: "long", year: "numeric" }) : ""}
                  {p.author ? ` · ${p.author}` : ""}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
